import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';

const Timer = () => {
  const [time, setTime] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((t: number) => t + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (time: number) =>
    `${String(Math.floor(time / 60)).padStart(2, '0')}:${String(time % 60).padStart(2, '0')}`;

  return <Typography variant="subtitle1">{formatTime(time)}</Typography>;
};

export default Timer;
